import { render, staticRenderFns } from "./SynonymsHelp.vue?vue&type=template&id=571bbbea&scoped=true"
import script from "./SynonymsHelp.vue?vue&type=script&lang=js"
export * from "./SynonymsHelp.vue?vue&type=script&lang=js"
import style0 from "./SynonymsHelp.vue?vue&type=style&index=0&id=571bbbea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571bbbea",
  null
  
)

export default component.exports